module.exports = __webpack_public_path__ + "img/img47.f4e1842f.svg";